import { useAppDispatch, useAppSelector } from 'app/store';
import {
  getConnectionUrlLoadingState,
  getWebSocketConnectionUrl,
} from 'app/store/WebSockets/selectors';
import { useCallback, useEffect, useRef } from 'react';
import { fetchCreateSignedConnectionUrlEffect } from 'app/store/WebSockets/effects';
import { LoadingState } from 'types/enums';
import { setWebSocketConnectionData } from 'app/store/WebSockets/slice';
import debounce from 'lodash/debounce';

interface UseWebSocketConnectionLinkProps {
  shouldFetchSignedConnectionUrl?: boolean;
}

export const useWebSocketConnectionLink = (
  props?: UseWebSocketConnectionLinkProps
) => {
  const { shouldFetchSignedConnectionUrl } = props || {};
  const dispatch = useAppDispatch();
  const connectionUrl = useAppSelector(getWebSocketConnectionUrl);
  const connectionUrlLoadingState = useAppSelector(
    getConnectionUrlLoadingState
  );
  const loadingStateRef = useRef(connectionUrlLoadingState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchConnectionUrl = useCallback(
    debounce(() => {
      if (loadingStateRef.current !== LoadingState.FETCHING) {
        dispatch(fetchCreateSignedConnectionUrlEffect());
      }
    }, 300), // SS-8792 safeguard for unexpected loop.
    []
  );

  useEffect(() => {
    if (!connectionUrl && shouldFetchSignedConnectionUrl) {
      fetchConnectionUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionUrl, shouldFetchSignedConnectionUrl]);

  useEffect(() => {
    loadingStateRef.current = connectionUrlLoadingState;
  }, [connectionUrlLoadingState]);

  return {
    connectionUrl,
    setConnectionUrl: (connectionUrl: string | null) =>
      dispatch(setWebSocketConnectionData(connectionUrl)),
    refetchConnectionUrl: fetchConnectionUrl,
  };
};
